import React from 'react';
import type { FC, ReactNode } from 'react';
import { DeleteConfirmModal } from '../DeleteConfirmModal/DeleteConfirmModal';

interface ConfirmDeleteModalProps {
    open: boolean;
    title: string;
    name?: string;
    items: string[];
    warnText?: ReactNode;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
    open,
    title,
    name,
    items,
    warnText,
    loading = false,
    onCancel,
    onConfirm,
}) => (
    <DeleteConfirmModal
        open={open}
        title={title}
        name={name}
        items={items}
        warnText={warnText}
        busy={loading}
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);